import React, { useState, useEffect } from 'react'
import { formValueSelector, reduxForm } from 'redux-form'
import InputTable from '../../../Stock/components/estimacionStock/InputTable'
import { FORM_BUQUES } from '../../../../config/forms'
import { connect } from 'react-redux'
import { actualizarDetalleCarga } from '../../actions/TablaCargaBuquesActions'

function ToneladasACargar (props) {
  const { value, entry, change: formChange, toneladasCarga, actualizarDetalleCarga } = props
  const [cantidad, setCantidad] = useState(value)

  useEffect(() => {
    setCantidad(value)
  }, [value])

  const handleDisplay = () => {
    formChange('toneladas', cantidad)
    formChange('fechaAnuncio', entry.fechaAnuncio)
    formChange('fechaCarga', entry.fechaDeCarga)
    formChange('exportadorOld', entry.exportador)
    formChange('cereal', entry.claveCereal)
  }

  const handleBlur = () => {
    if (!isNaN(toneladasCarga) && toneladasCarga !== cantidad) {
      setCantidad(toneladasCarga)
      actualizarDetalleCarga()
    }
  }

  return (
    <>
      {cantidad &&
        <div className='input-table-edit'>
          {/* <EditarCarga data={entry} /> */}
          <InputTable
            name='toneladas'
            icono={null}
            value={cantidad}
            handleDisplay={handleDisplay}
            handleBlur={handleBlur}
            justifyContent='flex-start'
          />
        </div>
      }
    </>
  )
}

const selector = formValueSelector(FORM_BUQUES)
const mapStateToProps = (state) => ({
  toneladasCarga: selector(state, 'toneladas')
})

const mapActionsToProps = {
  actualizarDetalleCarga
  // obtenerCargasBuque
}

const withRedux = connect(mapStateToProps, mapActionsToProps)
const withReduxForm = reduxForm({
  form: FORM_BUQUES
})

export default withRedux(withReduxForm(ToneladasACargar))
